import { AsyncResponseData, constructResponseData } from 'utils/fetchWrapper/fetchWrapper';
import { IHomePageInfo } from 'utils/DexieDBManager/dexieDB.models';
import fetchWrapper from 'utils/fetchWrapper';

export type HomePageInfoKeys = keyof IHomePageInfo;

const getHeaderDataAndSendMessageToSW = async (homePageInfo: IHomePageInfo) => {
  navigator.serviceWorker?.controller?.postMessage({
    type: 'ADD_HOME_PAGE_INFO_TO_INDEXED_DB',
    homePageInfo: JSON.stringify(homePageInfo),
  });
};

export const getHomePageInfoAsync = async (userId: string): Promise<AsyncResponseData<IHomePageInfo>> => {
  const response = await fetchWrapper.get(`${process.env.REACT_APP_BACK_END_API}/users/${userId}/homePageInfo`);

  const failureMessage = 'Le chargement des données de la home page a échoué';

  const homePageInfoData = await constructResponseData<IHomePageInfo>(response, failureMessage);

  if (homePageInfoData.isSuccess && homePageInfoData.responseData) {
    getHeaderDataAndSendMessageToSW(homePageInfoData.responseData);
  }
  return homePageInfoData;
};

